import gql from 'graphql-tag';
const SENTENCES_DOCTOR_ACTIVITY_FRAGMENT = gql `
  fragment SentenceDoctorActivityFragment on SentenceDoctorActivity {
    rounds {
      roundIndex
      optionalInstructions: instructions
      optionalImage: image
      startTextBubble
      endTextBubble
      incorrectSentence
      selectList {
        answer
        isCorrectAnswer
        isSelected
      }
      steps {
        stepIndex
        answer
      }
    }
  }
`;
export default SENTENCES_DOCTOR_ACTIVITY_FRAGMENT;
